/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Tax Assist Manager Client API
 * Client API for Tax Assist Manager platform providing role-based access for end users.

This API is designed for web applications, mobile apps, and user-facing integrations.
All endpoints require Cognito JWT authentication with appropriate role permissions.

**Authentication**: Cognito JWT Bearer Token
**Base URL**: `https://api-assist.harness-dev.com/api/v1`

## User Roles
- **Admin**: Full access to all operations across all firms
- **Reviewer**: Internal reviewer with cross-firm read-only access, no management capabilities
- **Firm Admin**: Limited access to manage their assigned firms and users
- **Firm User**: Access to create and manage jobs within their assigned firms

## Data Isolation
All operations are scoped to the user's assigned firms. Users can only access
data belonging to firms they are authorized to work with.

 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import { customAxiosInstance } from "../config/axios";
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetMissingDocVerdictRequestVerdict = {
    verified_present: "verified_present",
    not_required: "not_required",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MissingDocVerdictResponseVerdict = {
    verified_present: "verified_present",
    not_required: "not_required",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TriggerVerifyBinderResultItemArtifactType = {
    binder: "binder",
    supporting_doc: "supporting_doc",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BinderVerificationSummaryRowStatus = {
    verified: "verified",
    issues_found: "issues_found",
    unverifiable: "unverifiable",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BinderVerificationSummaryRowPipelineStatus = {
    pending: "pending",
    processing: "processing",
    completed: "completed",
    failed: "failed",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateProcessingResultUploadUrlBodyArtifactType = {
    binder: "binder",
    k1_worksheets: "k1_worksheets",
    supporting_doc: "supporting_doc",
    other: "other",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetJobProcessingResults200ProcessingResultsItemArtifactType = {
    binder: "binder",
    k1_worksheets: "k1_worksheets",
    supporting_doc: "supporting_doc",
    other: "other",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateProcessingResultArtifactBodyArtifactType = {
    binder: "binder",
    k1_worksheets: "k1_worksheets",
    supporting_doc: "supporting_doc",
    other: "other",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateProcessingResultArtifact200ArtifactType = {
    binder: "binder",
    k1_worksheets: "k1_worksheets",
    supporting_doc: "supporting_doc",
    other: "other",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateUploadedFileBodyDocumentType = {
    w2: "w2",
    NUMBER_1099: "1099",
    k1: "k1",
    other: "other",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateUploadedFile200DocumentType = {
    w2: "w2",
    NUMBER_1099: "1099",
    k1: "k1",
    other: "other",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAuditTrailAsUserResourceType = {
    FIRM: "FIRM",
    JOB: "JOB",
    DOCUMENT: "DOCUMENT",
    USER: "USER",
    SYSTEM: "SYSTEM",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAuditTrailAsUserAction = {
    CREATE: "CREATE",
    READ: "READ",
    UPDATE: "UPDATE",
    DELETE: "DELETE",
    SUBMIT: "SUBMIT",
    UPLOAD: "UPLOAD",
    LOGIN: "LOGIN",
    LOGOUT: "LOGOUT",
    ACCESS_DENIED: "ACCESS_DENIED",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAuditTrailAsUser200RecordsItemAuthType = {
    IAM: "IAM",
    COGNITO: "COGNITO",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAuditTrailAsUser200RecordsItemAction = {
    CREATE: "CREATE",
    READ: "READ",
    UPDATE: "UPDATE",
    DELETE: "DELETE",
    SUBMIT: "SUBMIT",
    UPLOAD: "UPLOAD",
    LOGIN: "LOGIN",
    LOGOUT: "LOGOUT",
    ACCESS_DENIED: "ACCESS_DENIED",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAuditTrailAsUser200RecordsItemResourceType = {
    FIRM: "FIRM",
    JOB: "JOB",
    DOCUMENT: "DOCUMENT",
    USER: "USER",
    SYSTEM: "SYSTEM",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListFirmUsersStatus = {
    FORCE_CHANGE_PASSWORD: "FORCE_CHANGE_PASSWORD",
    CONFIRMED: "CONFIRMED",
    UNCONFIRMED: "UNCONFIRMED",
    DISABLED: "DISABLED",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOpsJobsStatus = {
    TRIAGE: "TRIAGE",
    SUBMITTED: "SUBMITTED",
    PROCESSING: "PROCESSING",
    VERIFIED: "VERIFIED",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOpsJobsPriority = {
    HIGH: "HIGH",
    NORMAL: "NORMAL",
    LOW: "LOW",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOpsJobsInactive = {
    true: "true",
    false: "false",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOpsJobsSortBy = {
    createdAt: "createdAt",
    priority: "priority",
    etaNum: "etaNum",
    status: "status",
    firmName: "firmName",
    clientName: "clientName",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOpsJobsSortOrder = {
    asc: "asc",
    desc: "desc",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMyActiveJobs200JobsItemStatus = {
    VERIFICATION: "VERIFICATION",
    VERIFIED: "VERIFIED",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListAllUsersRolesItem = {
    admin: "admin",
    reviewer: "reviewer",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListAllUsers200UsersItemRole = {
    admin: "admin",
    reviewer: "reviewer",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompleteJob200NewStatus = {
    DONE: "DONE",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompleteJob200PreviousStatus = {
    VERIFIED: "VERIFIED",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UndoCompleteJob200NewStatus = {
    VERIFIED: "VERIFIED",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UndoCompleteJob200PreviousStatus = {
    DONE: "DONE",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBinderVerificationSummaryFilter = {
    all: "all",
    issues_found: "issues_found",
    verified: "verified",
    unverifiable: "unverifiable",
    partially_scanned: "partially_scanned",
    processing: "processing",
    unverified: "unverified",
    reviewer_complete: "reviewer_complete",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FilingType = {
    NUMBER_1040: "1040",
    NUMBER_1041: "1041",
    NUMBER_1065: "1065",
    NUMBER_1120: "1120",
    "1120S": "1120S",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobStatus = {
    DRAFT: "DRAFT",
    TRIAGE: "TRIAGE",
    NEW_FILES: "NEW_FILES",
    SUBMITTED: "SUBMITTED",
    PROCESSING: "PROCESSING",
    DOWNLOAD_TO_PROCESS: "DOWNLOAD_TO_PROCESS",
    VERIFICATION: "VERIFICATION",
    VERIFIED: "VERIFIED",
    DONE: "DONE",
    ERROR: "ERROR",
    CANCELLED: "CANCELLED",
    ARCHIVED: "ARCHIVED",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UploadedFileDocumentType = {
    w2: "w2",
    NUMBER_1099: "1099",
    k1: "k1",
    other: "other",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurePrepFirmConfigHasLeadsheet = {
    NUMBER_0: 0,
    NUMBER_1: 1,
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateFirmRequestSurePrepConfigHasLeadsheet = {
    NUMBER_0: 0,
    NUMBER_1: 1,
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubmitJobRequestMetadataPriority = {
    normal: "normal",
    expedited: "expedited",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OpsJobItemPriority = {
    HIGH: "HIGH",
    NORMAL: "NORMAL",
    LOW: "LOW",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessingResultArtifactArtifactType = {
    binder: "binder",
    k1_worksheets: "k1_worksheets",
    supporting_doc: "supporting_doc",
    other: "other",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StatusQueryParameter = {
    DRAFT: "DRAFT",
    TRIAGE: "TRIAGE",
    NEW_FILES: "NEW_FILES",
    SUBMITTED: "SUBMITTED",
    PROCESSING: "PROCESSING",
    DOWNLOAD_TO_PROCESS: "DOWNLOAD_TO_PROCESS",
    VERIFICATION: "VERIFICATION",
    VERIFIED: "VERIFIED",
    DONE: "DONE",
    ERROR: "ERROR",
    CANCELLED: "CANCELLED",
    ARCHIVED: "ARCHIVED",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FilingTypeQueryParameter = {
    NUMBER_1040: "1040",
    NUMBER_1041: "1041",
    NUMBER_1065: "1065",
    NUMBER_1120: "1120",
    "1120S": "1120S",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserRole = {
    admin: "admin",
    reviewer: "reviewer",
    firm_admin: "firm_admin",
    firm_user: "firm_user",
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FirmUserStatus = {
    FORCE_CHANGE_PASSWORD: "FORCE_CHANGE_PASSWORD",
    CONFIRMED: "CONFIRMED",
    UNCONFIRMED: "UNCONFIRMED",
    DISABLED: "DISABLED",
};
/**
 * Retrieve the current user's profile information including role and assigned firms.
This endpoint helps users discover which firms they have access to.

 * @summary Get user profile
 */
export const getUserProfile = (signal) => {
    return customAxiosInstance({
        url: `/profile`,
        method: "GET",
        signal,
    });
};
export const getGetUserProfileQueryKey = () => {
    return [`/profile`];
};
export const getGetUserProfileQueryOptions = (options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetUserProfileQueryKey();
    const queryFn = ({ signal, }) => getUserProfile(signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Get user profile
 */
export function useGetUserProfile(options) {
    const queryOptions = getGetUserProfileQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Retrieve firms accessible to the current user based on their role and assignments.
- **Admin**: Access to all firms
- **Reviewer**: Access to all firms (read-only)
- **Firm Admin**: Access to assigned firms only
- **Firm User**: Read-only access to assigned firms

 * @summary List accessible firms
 */
export const listAccessibleFirms = (params, signal) => {
    return customAxiosInstance({
        url: `/firms`,
        method: "GET",
        params,
        signal,
    });
};
export const getListAccessibleFirmsQueryKey = (params) => {
    return [`/firms`, ...(params ? [params] : [])];
};
export const getListAccessibleFirmsQueryOptions = (params, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListAccessibleFirmsQueryKey(params);
    const queryFn = ({ signal }) => listAccessibleFirms(params, signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary List accessible firms
 */
export function useListAccessibleFirms(params, options) {
    const queryOptions = getListAccessibleFirmsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Create a new firm. Only available to Admin role users.
This endpoint is restricted to administrative users only.

 * @summary Create a new firm
 */
export const createFirmAsUser = (createFirmRequest, signal) => {
    return customAxiosInstance({
        url: `/firms`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createFirmRequest,
        signal,
    });
};
export const getCreateFirmAsUserMutationOptions = (options) => {
    const mutationKey = ["createFirmAsUser"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createFirmAsUser(data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Create a new firm
 */
export const useCreateFirmAsUser = (options) => {
    const mutationOptions = getCreateFirmAsUserMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Retrieve detailed information about a specific firm.
Users can only access firms they are assigned to.

 * @summary Get firm details
 */
export const getFirmAsUser = (firmId, signal) => {
    return customAxiosInstance({
        url: `/firms/${firmId}`,
        method: "GET",
        signal,
    });
};
export const getGetFirmAsUserQueryKey = (firmId) => {
    return [`/firms/${firmId}`];
};
export const getGetFirmAsUserQueryOptions = (firmId, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFirmAsUserQueryKey(firmId);
    const queryFn = ({ signal, }) => getFirmAsUser(firmId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!firmId,
        ...queryOptions,
    };
};
/**
 * @summary Get firm details
 */
export function useGetFirmAsUser(firmId, options) {
    const queryOptions = getGetFirmAsUserQueryOptions(firmId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Update firm information. Available to Admin and Firm Admin roles.

**Field Permissions**:
- **Admin**: Can update all fields
- **Firm Admin**: Can update limited fields (name, address, phone, email, some SurePrep config)
- **Firm User**: No update access

 * @summary Update firm
 */
export const updateFirmAsUser = (firmId, updateFirmRequest) => {
    return customAxiosInstance({
        url: `/firms/${firmId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        data: updateFirmRequest,
    });
};
export const getUpdateFirmAsUserMutationOptions = (options) => {
    const mutationKey = ["updateFirmAsUser"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { firmId, data } = props ?? {};
        return updateFirmAsUser(firmId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Update firm
 */
export const useUpdateFirmAsUser = (options) => {
    const mutationOptions = getUpdateFirmAsUserMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Partially update firm information using JSON Patch semantics.
Only provided fields will be updated, others remain unchanged.

**Field Permissions**:
- **Admin**: Can update all fields
- **Firm Admin**: Can update limited fields (name, address, phone, email, some SurePrep config)
- **Firm User**: No update access

**Difference from PUT**:
- PUT requires all fields and replaces the entire resource
- PATCH allows selective updates of individual fields

 * @summary Partially update firm
 */
export const patchFirmAsUser = (firmId, updateFirmRequest) => {
    return customAxiosInstance({
        url: `/firms/${firmId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateFirmRequest,
    });
};
export const getPatchFirmAsUserMutationOptions = (options) => {
    const mutationKey = ["patchFirmAsUser"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { firmId, data } = props ?? {};
        return patchFirmAsUser(firmId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Partially update firm
 */
export const usePatchFirmAsUser = (options) => {
    const mutationOptions = getPatchFirmAsUserMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Add a new batch of credits to a firm with expiry date and reason.
Available to Admin users only for managing firm credit allocations.

**Role Access:**
- **Admin**: Can add credits to any firm
- **Reviewer**: Read-only access, cannot add credits
- **Firm Admin**: Cannot add credits (business restriction)
- **Firm User**: Cannot add credits (business restriction)

**Business Rules:**
- Credits must be positive integers between 1 and 10,000
- Expiry date must be in the future
- Reason is required for audit trail purposes
- All credit additions are logged for compliance

 * @summary Add credit batch to firm
 */
export const addCreditBatchToFirm = (firmId, addCreditBatchToFirmBody, signal) => {
    return customAxiosInstance({
        url: `/firms/${firmId}/credits`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: addCreditBatchToFirmBody,
        signal,
    });
};
export const getAddCreditBatchToFirmMutationOptions = (options) => {
    const mutationKey = ["addCreditBatchToFirm"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { firmId, data } = props ?? {};
        return addCreditBatchToFirm(firmId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Add credit batch to firm
 */
export const useAddCreditBatchToFirm = (options) => {
    const mutationOptions = getAddCreditBatchToFirmMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Retrieve jobs for a specific firm. Users can only access jobs for firms
they are assigned to.

 * @summary List jobs for firm
 */
export const listJobsForFirmAsUser = (firmId, params, signal) => {
    return customAxiosInstance({
        url: `/firms/${firmId}/jobs`,
        method: "GET",
        params,
        signal,
    });
};
export const getListJobsForFirmAsUserQueryKey = (firmId, params) => {
    return [`/firms/${firmId}/jobs`, ...(params ? [params] : [])];
};
export const getListJobsForFirmAsUserQueryOptions = (firmId, params, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListJobsForFirmAsUserQueryKey(firmId, params);
    const queryFn = ({ signal }) => listJobsForFirmAsUser(firmId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!firmId,
        ...queryOptions,
    };
};
/**
 * @summary List jobs for firm
 */
export function useListJobsForFirmAsUser(firmId, params, options) {
    const queryOptions = getListJobsForFirmAsUserQueryOptions(firmId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Create a new tax return job for the specified firm.
Available to all roles for their assigned firms.

 * @summary Create job for firm
 */
export const createJobForFirmAsUser = (firmId, createJobRequest, signal) => {
    return customAxiosInstance({
        url: `/firms/${firmId}/jobs`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createJobRequest,
        signal,
    });
};
export const getCreateJobForFirmAsUserMutationOptions = (options) => {
    const mutationKey = ["createJobForFirmAsUser"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { firmId, data } = props ?? {};
        return createJobForFirmAsUser(firmId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Create job for firm
 */
export const useCreateJobForFirmAsUser = (options) => {
    const mutationOptions = getCreateJobForFirmAsUserMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Retrieve detailed information for a specific job.
Users can only access jobs for firms they are assigned to.

 * @summary Get job details
 */
export const getJobAsUser = (firmId, jobId, signal) => {
    return customAxiosInstance({
        url: `/firms/${firmId}/jobs/${jobId}`,
        method: "GET",
        signal,
    });
};
export const getGetJobAsUserQueryKey = (firmId, jobId) => {
    return [`/firms/${firmId}/jobs/${jobId}`];
};
export const getGetJobAsUserQueryOptions = (firmId, jobId, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetJobAsUserQueryKey(firmId, jobId);
    const queryFn = ({ signal, }) => getJobAsUser(firmId, jobId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(firmId && jobId),
        ...queryOptions,
    };
};
/**
 * @summary Get job details
 */
export function useGetJobAsUser(firmId, jobId, options) {
    const queryOptions = getGetJobAsUserQueryOptions(firmId, jobId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Check if a file with the same content (based on MD5 hash) already exists for a job.

 * @summary Check for duplicate file
 */
export const checkDuplicateFileAsUser = (firmId, jobId, checkDuplicateFileAsUserBody, signal) => {
    return customAxiosInstance({
        url: `/firms/${firmId}/jobs/${jobId}/check-duplicate-file`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: checkDuplicateFileAsUserBody,
        signal,
    });
};
export const getCheckDuplicateFileAsUserMutationOptions = (options) => {
    const mutationKey = ["checkDuplicateFileAsUser"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { firmId, jobId, data } = props ?? {};
        return checkDuplicateFileAsUser(firmId, jobId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Check for duplicate file
 */
export const useCheckDuplicateFileAsUser = (options) => {
    const mutationOptions = getCheckDuplicateFileAsUserMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Generate a pre-signed URL for uploading files to a job.
Users can only generate upload URLs for jobs in their assigned firms.

 * @summary Generate upload URL for job
 */
export const generateJobUploadUrlAsUser = (firmId, jobId, generateUploadUrlRequest, signal) => {
    return customAxiosInstance({
        url: `/firms/${firmId}/jobs/${jobId}/generate-upload-url`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: generateUploadUrlRequest,
        signal,
    });
};
export const getGenerateJobUploadUrlAsUserMutationOptions = (options) => {
    const mutationKey = ["generateJobUploadUrlAsUser"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { firmId, jobId, data } = props ?? {};
        return generateJobUploadUrlAsUser(firmId, jobId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Generate upload URL for job
 */
export const useGenerateJobUploadUrlAsUser = (options) => {
    const mutationOptions = getGenerateJobUploadUrlAsUserMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Reports a file validation error for a specific firm and job.
Errors are written to CloudWatch (via Powertools Logger) for auditing and troubleshooting.

 * @summary Log a file validation failure
 */
export const postFirmsFirmIdJobsJobIdLogFileError = (firmId, jobId, postFirmsFirmIdJobsJobIdLogFileErrorBody, signal) => {
    return customAxiosInstance({
        url: `/firms/${firmId}/jobs/${jobId}/log-file-error`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: postFirmsFirmIdJobsJobIdLogFileErrorBody,
        signal,
    });
};
export const getPostFirmsFirmIdJobsJobIdLogFileErrorMutationOptions = (options) => {
    const mutationKey = ["postFirmsFirmIdJobsJobIdLogFileError"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { firmId, jobId, data } = props ?? {};
        return postFirmsFirmIdJobsJobIdLogFileError(firmId, jobId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Log a file validation failure
 */
export const usePostFirmsFirmIdJobsJobIdLogFileError = (options) => {
    const mutationOptions = getPostFirmsFirmIdJobsJobIdLogFileErrorMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Submit the job to the triage queue for processing.
Users can only submit jobs belonging to their assigned firms.

**Access Control**:
- Users must have access to the specified firm
- Job must be in DRAFT status with at least one uploaded file
- Credits are consumed upon submission (if not already charged)

 * @summary Submit job for processing
 */
export const submitJobAsUser = (firmId, jobId, submitJobRequest, signal) => {
    return customAxiosInstance({
        url: `/firms/${firmId}/jobs/${jobId}/submit`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: submitJobRequest,
        signal,
    });
};
export const getSubmitJobAsUserMutationOptions = (options) => {
    const mutationKey = ["submitJobAsUser"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { firmId, jobId, data } = props ?? {};
        return submitJobAsUser(firmId, jobId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Submit job for processing
 */
export const useSubmitJobAsUser = (options) => {
    const mutationOptions = getSubmitJobAsUserMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Retrieve processing results/artifacts for a completed job.
Users can only access processing results for jobs belonging to their assigned firms.

**Access Control**:
- Users must have access to the specified firm
- All user roles (firm_user, firm_admin, reviewer, admin) can view processing results
- Results are only available for jobs that have been processed

 * @summary Get job processing results
 */
export const getJobProcessingResultsAsUser = (firmId, jobId, signal) => {
    return customAxiosInstance({
        url: `/firms/${firmId}/jobs/${jobId}/processing-results`,
        method: "GET",
        signal,
    });
};
export const getGetJobProcessingResultsAsUserQueryKey = (firmId, jobId) => {
    return [`/firms/${firmId}/jobs/${jobId}/processing-results`];
};
export const getGetJobProcessingResultsAsUserQueryOptions = (firmId, jobId, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ??
        getGetJobProcessingResultsAsUserQueryKey(firmId, jobId);
    const queryFn = ({ signal }) => getJobProcessingResultsAsUser(firmId, jobId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(firmId && jobId),
        ...queryOptions,
    };
};
/**
 * @summary Get job processing results
 */
export function useGetJobProcessingResultsAsUser(firmId, jobId, options) {
    const queryOptions = getGetJobProcessingResultsAsUserQueryOptions(firmId, jobId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Generate a pre-signed URL for downloading a processing result file with proper download headers.
Users can only download processing results from jobs in their assigned firms.

The S3 key follows the format: `firms/{firmId}/jobs/{jobId}/processing-results/{artifactId}/{fileName}`

**Access Control**:
- All authenticated users can download processing results they have access to
- Users must have access to the firm that owns the job
- URLs are time-limited and expire after a configured duration
- Downloads are logged for audit purposes

 * @summary Download processing result file
 */
export const downloadJobProcessingResultAsUser = (firmId, jobId, params, signal) => {
    return customAxiosInstance({
        url: `/firms/${firmId}/jobs/${jobId}/processing-results/download`,
        method: "GET",
        params,
        signal,
    });
};
export const getDownloadJobProcessingResultAsUserQueryKey = (firmId, jobId, params) => {
    return [
        `/firms/${firmId}/jobs/${jobId}/processing-results/download`,
        ...(params ? [params] : []),
    ];
};
export const getDownloadJobProcessingResultAsUserQueryOptions = (firmId, jobId, params, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ??
        getDownloadJobProcessingResultAsUserQueryKey(firmId, jobId, params);
    const queryFn = ({ signal }) => downloadJobProcessingResultAsUser(firmId, jobId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(firmId && jobId),
        ...queryOptions,
    };
};
/**
 * @summary Download processing result file
 */
export function useDownloadJobProcessingResultAsUser(firmId, jobId, params, options) {
    const queryOptions = getDownloadJobProcessingResultAsUserQueryOptions(firmId, jobId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Generate a zip file containing all processing results for a job and return a pre-signed URL for download.
Users can only download processing results from jobs in their assigned firms.

The handler will:
1. Check if a valid cached zip exists
2. If cached zip is outdated or missing, create new zip:
   - Retrieve all processing results from the job
   - Download each file from S3
   - Create a zip file organized by artifact type
   - Upload to temporary S3 location
3. Return a pre-signed URL for download

**Smart Caching**: The handler reuses existing zips when all processing result files are older than the cached zip. A new zip is created if any file is newer than the cached zip.

The zip file URL expires after 1 hour. Files are automatically cleaned up by S3 lifecycle rules after 1 day.

**Access Control**:
- All authenticated users can download processing results they have access to
- Users must have access to the firm that owns the job
- URLs are time-limited and expire after 1 hour
- Downloads are logged for audit purposes

 * @summary Download all processing results as a zip file
 */
export const downloadAllProcessingResults = (jobId, signal) => {
    return customAxiosInstance({
        url: `/jobs/${jobId}/processing-results/download-all`,
        method: "GET",
        signal,
    });
};
export const getDownloadAllProcessingResultsQueryKey = (jobId) => {
    return [`/jobs/${jobId}/processing-results/download-all`];
};
export const getDownloadAllProcessingResultsQueryOptions = (jobId, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getDownloadAllProcessingResultsQueryKey(jobId);
    const queryFn = ({ signal }) => downloadAllProcessingResults(jobId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!jobId,
        ...queryOptions,
    };
};
/**
 * @summary Download all processing results as a zip file
 */
export function useDownloadAllProcessingResults(jobId, options) {
    const queryOptions = getDownloadAllProcessingResultsQueryOptions(jobId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Delete a specific file from a job by its S3 key.
Users can only delete files from jobs in their assigned firms.

The S3 key follows the format: `firms/{firmId}/jobs/{jobId}/{fileId}/{fileName}`

**Access Control**:
- All authenticated users can delete files they have access to
- Users must have access to the firm that owns the job
- Files are immediately removed from both the job record and S3 storage

 * @summary Delete job file
 */
export const deleteJobFileAsUser = (firmId, jobId, params) => {
    return customAxiosInstance({
        url: `/firms/${firmId}/jobs/${jobId}/files`,
        method: "DELETE",
        params,
    });
};
export const getDeleteJobFileAsUserMutationOptions = (options) => {
    const mutationKey = ["deleteJobFileAsUser"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { firmId, jobId, params } = props ?? {};
        return deleteJobFileAsUser(firmId, jobId, params);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Delete job file
 */
export const useDeleteJobFileAsUser = (options) => {
    const mutationOptions = getDeleteJobFileAsUserMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Generate a pre-signed URL for downloading a file with proper download headers.
Users can only download files from jobs in their assigned firms.

The S3 key follows the format: `firms/{firmId}/jobs/{jobId}/{fileId}/{fileName}`

**Access Control**:
- All authenticated users can download files they have access to
- Users must have access to the firm that owns the job
- URLs are time-limited and expire after a configured duration
- Downloads are logged for audit purposes

 * @summary Download job file
 */
export const downloadJobFileAsUser = (firmId, jobId, params, signal) => {
    return customAxiosInstance({
        url: `/firms/${firmId}/jobs/${jobId}/files/download`,
        method: "GET",
        params,
        signal,
    });
};
export const getDownloadJobFileAsUserQueryKey = (firmId, jobId, params) => {
    return [
        `/firms/${firmId}/jobs/${jobId}/files/download`,
        ...(params ? [params] : []),
    ];
};
export const getDownloadJobFileAsUserQueryOptions = (firmId, jobId, params, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ??
        getDownloadJobFileAsUserQueryKey(firmId, jobId, params);
    const queryFn = ({ signal }) => downloadJobFileAsUser(firmId, jobId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(firmId && jobId),
        ...queryOptions,
    };
};
/**
 * @summary Download job file
 */
export function useDownloadJobFileAsUser(firmId, jobId, params, options) {
    const queryOptions = getDownloadJobFileAsUserQueryOptions(firmId, jobId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Generate a pre-signed URL for previewing/downloading a file.
Users can only preview files from jobs in their assigned firms.

The S3 key follows the format: `firms/{firmId}/jobs/{jobId}/{fileId}/{fileName}`

**Access Control**:
- All authenticated users can preview files they have access to
- Users must have access to the firm that owns the job
- URLs are time-limited and expire after a configured duration

 * @summary Generate file preview URL
 */
export const generateFilePreviewUrlAsUser = (params, signal) => {
    return customAxiosInstance({
        url: `/files/preview`,
        method: "GET",
        params,
        signal,
    });
};
export const getGenerateFilePreviewUrlAsUserQueryKey = (params) => {
    return [`/files/preview`, ...(params ? [params] : [])];
};
export const getGenerateFilePreviewUrlAsUserQueryOptions = (params, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGenerateFilePreviewUrlAsUserQueryKey(params);
    const queryFn = ({ signal }) => generateFilePreviewUrlAsUser(params, signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Generate file preview URL
 */
export function useGenerateFilePreviewUrlAsUser(params, options) {
    const queryOptions = getGenerateFilePreviewUrlAsUserQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Generate a pre-signed URL for uploading processing result files to a completed job.
This endpoint is restricted to Admin and Reviewer roles only and should be used
to upload final tax documents, worksheets, and supporting materials.

**Access Control**:
- **Admin**: Can upload processing results for any job
- **Reviewer**: Can upload processing results for any job
- **Firm Admin/User**: No access (403 Forbidden)

**Use Cases**:
- Upload completed tax returns and schedules
- Add processing worksheets and calculations
- Attach supporting documentation and notes

Processing result files use a different S3 key pattern:
`firms/{firmId}/jobs/{jobId}/processing-results/{fileId}/{fileName}`

 * @summary Generate upload URL for processing results
 */
export const generateProcessingResultUploadUrl = (jobId, generateProcessingResultUploadUrlBody, signal) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/processing-results/upload-url`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: generateProcessingResultUploadUrlBody,
        signal,
    });
};
export const getGenerateProcessingResultUploadUrlMutationOptions = (options) => {
    const mutationKey = ["generateProcessingResultUploadUrl"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId, data } = props ?? {};
        return generateProcessingResultUploadUrl(jobId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Generate upload URL for processing results
 */
export const useGenerateProcessingResultUploadUrl = (options) => {
    const mutationOptions = getGenerateProcessingResultUploadUrlMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Retrieve all processing result artifacts for a job.
This endpoint is restricted to Admin and Reviewer roles only.

**Access Control**:
- **Admin**: Can view processing results for any job
- **Reviewer**: Can view processing results for any job
- **Firm Admin/User**: No access (403 Forbidden)

**Use Cases**:
- View completed tax documents and schedules
- Access processing worksheets and calculations
- Download supporting documentation

 * @summary Get processing results for job
 */
export const getJobProcessingResults = (jobId, signal) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/processing-results`,
        method: "GET",
        signal,
    });
};
export const getGetJobProcessingResultsQueryKey = (jobId) => {
    return [`/ops/jobs/${jobId}/processing-results`];
};
export const getGetJobProcessingResultsQueryOptions = (jobId, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetJobProcessingResultsQueryKey(jobId);
    const queryFn = ({ signal }) => getJobProcessingResults(jobId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!jobId,
        ...queryOptions,
    };
};
/**
 * @summary Get processing results for job
 */
export function useGetJobProcessingResults(jobId, options) {
    const queryOptions = getGetJobProcessingResultsQueryOptions(jobId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Delete a specific processing result artifact from a job.
This endpoint is restricted to Admin and Reviewer roles only.

**Access Control**:
- **Admin**: Can delete processing results for any job
- **Reviewer**: Can delete processing results for any job
- **Firm Admin/User**: No access (403 Forbidden)

**Use Cases**:
- Remove incorrect or outdated processing results
- Clean up test files during development
- Remove duplicate artifacts

**Security**:
- Deletion is permanent and cannot be undone
- Audit trail records the deletion event
- S3 object is permanently removed

 * @summary Delete processing result artifact
 */
export const deleteProcessingResultArtifact = (jobId, artifactId) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/processing-results/${artifactId}`,
        method: "DELETE",
    });
};
export const getDeleteProcessingResultArtifactMutationOptions = (options) => {
    const mutationKey = ["deleteProcessingResultArtifact"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId, artifactId } = props ?? {};
        return deleteProcessingResultArtifact(jobId, artifactId);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Delete processing result artifact
 */
export const useDeleteProcessingResultArtifact = (options) => {
    const mutationOptions = getDeleteProcessingResultArtifactMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Update attributes of a specific processing result artifact on a job (e.g. artifactType).
This endpoint is restricted to Admin and Reviewer roles only.

 * @summary Update processing result artifact
 */
export const updateProcessingResultArtifact = (jobId, artifactId, updateProcessingResultArtifactBody) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/processing-results/${artifactId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateProcessingResultArtifactBody,
    });
};
export const getUpdateProcessingResultArtifactMutationOptions = (options) => {
    const mutationKey = ["updateProcessingResultArtifact"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId, artifactId, data } = props ?? {};
        return updateProcessingResultArtifact(jobId, artifactId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Update processing result artifact
 */
export const useUpdateProcessingResultArtifact = (options) => {
    const mutationOptions = getUpdateProcessingResultArtifactMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Update attributes of a specific uploaded file on a job (e.g. documentType).
This endpoint is restricted to Admin and Reviewer roles only.

 * @summary Update uploaded file metadata
 */
export const updateUploadedFile = (jobId, s3Key, updateUploadedFileBody) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/uploaded-files/${s3Key}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateUploadedFileBody,
    });
};
export const getUpdateUploadedFileMutationOptions = (options) => {
    const mutationKey = ["updateUploadedFile"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId, s3Key, data } = props ?? {};
        return updateUploadedFile(jobId, s3Key, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Update uploaded file metadata
 */
export const useUpdateUploadedFile = (options) => {
    const mutationOptions = getUpdateUploadedFileMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Retrieve audit trail records for security, compliance, and monitoring purposes.

**Access Control:**
- **Admin**: Can view all audit records across all firms with full filtering
- **Reviewer**: Can view all audit records across all firms with full filtering (read-only)
- **Firm Admin**: Can view audit records for their assigned firms only (firmId required)
- **Firm User**: No access (403 Forbidden)

**Use Cases:**
- Security monitoring and incident investigation
- Compliance reporting and documentation
- User activity tracking and analysis
- System access auditing

 * @summary Get audit trail
 */
export const getAuditTrailAsUser = (params, signal) => {
    return customAxiosInstance({
        url: `/audit`,
        method: "GET",
        params,
        signal,
    });
};
export const getGetAuditTrailAsUserQueryKey = (params) => {
    return [`/audit`, ...(params ? [params] : [])];
};
export const getGetAuditTrailAsUserQueryOptions = (params, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAuditTrailAsUserQueryKey(params);
    const queryFn = ({ signal }) => getAuditTrailAsUser(params, signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Get audit trail
 */
export function useGetAuditTrailAsUser(params, options) {
    const queryOptions = getGetAuditTrailAsUserQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Retrieve all users who have access to the specified firm.
Available to Admin and Firm Admin roles only.

**Role Access:**
- **Admin**: Can list users for any firm
- **Reviewer**: Can list users for any firm (read-only)
- **Firm Admin**: Can list users for their assigned firms only
- **Firm User**: Not authorized

 * @summary List users in firm
 */
export const listFirmUsers = (firmId, params, signal) => {
    return customAxiosInstance({
        url: `/firms/${firmId}/users`,
        method: "GET",
        params,
        signal,
    });
};
export const getListFirmUsersQueryKey = (firmId, params) => {
    return [`/firms/${firmId}/users`, ...(params ? [params] : [])];
};
export const getListFirmUsersQueryOptions = (firmId, params, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListFirmUsersQueryKey(firmId, params);
    const queryFn = ({ signal, }) => listFirmUsers(firmId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!firmId,
        ...queryOptions,
    };
};
/**
 * @summary List users in firm
 */
export function useListFirmUsers(firmId, params, options) {
    const queryOptions = getListFirmUsersQueryOptions(firmId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Invite a new user to join the specified firm with the given role.
Available to Admin and Firm Admin roles only.

**Role Access:**
- **Admin**: Can invite users with any role to any firm (excluding REVIEWER which is internal-only)
- **Reviewer**: Cannot invite users (read-only role)
- **Firm Admin**: Can invite users with FIRM_ADMIN or FIRM_USER roles to their assigned firms
- **Firm User**: Not authorized

**Security Features:**
- Role elevation prevention: FIRM_ADMIN cannot create ADMIN users
- Email validation and uniqueness checking
- Automatic temporary password generation if not provided
- Comprehensive audit logging

 * @summary Invite user to firm
 */
export const inviteUserToFirm = (firmId, inviteUserRequest, signal) => {
    return customAxiosInstance({
        url: `/firms/${firmId}/users`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: inviteUserRequest,
        signal,
    });
};
export const getInviteUserToFirmMutationOptions = (options) => {
    const mutationKey = ["inviteUserToFirm"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { firmId, data } = props ?? {};
        return inviteUserToFirm(firmId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Invite user to firm
 */
export const useInviteUserToFirm = (options) => {
    const mutationOptions = getInviteUserToFirmMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Remove a user's access to the specified firm.
Available to Admin and Firm Admin roles only.

**Role Access:**
- **Admin**: Can remove users from any firm (excluding REVIEWER and ADMIN internal roles)
- **Reviewer**: Cannot remove users (read-only role)
- **Firm Admin**: Can remove users from their assigned firms
- **Firm User**: Not authorized

**Security Features:**
- Self-removal prevention: Users cannot remove themselves
- Last admin protection: Prevents removing the last admin from a firm
- Comprehensive audit logging
- Graceful handling of user not found scenarios

 * @summary Remove user from firm
 */
export const removeUserFromFirm = (firmId, userId) => {
    return customAxiosInstance({
        url: `/firms/${firmId}/users/${userId}`,
        method: "DELETE",
    });
};
export const getRemoveUserFromFirmMutationOptions = (options) => {
    const mutationKey = ["removeUserFromFirm"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { firmId, userId } = props ?? {};
        return removeUserFromFirm(firmId, userId);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Remove user from firm
 */
export const useRemoveUserFromFirm = (options) => {
    const mutationOptions = getRemoveUserFromFirmMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Update a user's role within the specified firm.
Available to Admin and Firm Admin roles only.

**Role Access:**
- **Admin**: Can update user roles in any firm (excluding REVIEWER and ADMIN internal roles)
- **Reviewer**: Cannot update user roles (read-only role)
- **Firm Admin**: Can update user roles in their assigned firms
- **Firm User**: Not authorized

**Business Rules:**
- Users cannot update their own role (self-modification prevention)
- Firm Admins cannot assign Admin role (privilege escalation prevention)
- Role must be valid for the requesting user's permission level

**Security Features:**
- Self-modification prevention: Users cannot change their own role
- Role hierarchy enforcement: Cannot elevate beyond current user's level
- Comprehensive audit logging
- Automatic Cognito group management

 * @summary Update user role in firm
 */
export const updateUserRoleInFirm = (firmId, userId, updateUserRoleRequest) => {
    return customAxiosInstance({
        url: `/firms/${firmId}/users/${userId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateUserRoleRequest,
    });
};
export const getUpdateUserRoleInFirmMutationOptions = (options) => {
    const mutationKey = ["updateUserRoleInFirm"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { firmId, userId, data } = props ?? {};
        return updateUserRoleInFirm(firmId, userId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Update user role in firm
 */
export const useUpdateUserRoleInFirm = (options) => {
    const mutationOptions = getUpdateUserRoleInFirmMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Create a new firm. Only available to Admin role users.

**Access**: Admin role only
**Use Cases:**
- Creating new client firms
- Administrative firm setup
- Initial firm configuration

 * @summary Create firm (Ops)
 */
export const createFirmOps = (createFirmRequest, signal) => {
    return customAxiosInstance({
        url: `/ops/firms`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createFirmRequest,
        signal,
    });
};
export const getCreateFirmOpsMutationOptions = (options) => {
    const mutationKey = ["createFirmOps"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createFirmOps(data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Create firm (Ops)
 */
export const useCreateFirmOps = (options) => {
    const mutationOptions = getCreateFirmOpsMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Update firm information. Only available to Admin role users.

**Access**: Admin role only
**Use Cases:**
- Administrative firm updates
- Internal configuration changes
- Status management (active/inactive)

 * @summary Update firm (Ops)
 */
export const updateFirmOps = (firmId, updateFirmRequest) => {
    return customAxiosInstance({
        url: `/ops/firms/${firmId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        data: updateFirmRequest,
    });
};
export const getUpdateFirmOpsMutationOptions = (options) => {
    const mutationKey = ["updateFirmOps"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { firmId, data } = props ?? {};
        return updateFirmOps(firmId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Update firm (Ops)
 */
export const useUpdateFirmOps = (options) => {
    const mutationOptions = getUpdateFirmOpsMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Partially update firm information using JSON Patch semantics.
Only available to Admin role users.

**Access**: Admin role only
**Use Cases:**
- Administrative partial updates
- Status changes
- Configuration adjustments

 * @summary Partially update firm (Ops)
 */
export const patchFirmOps = (firmId, updateFirmRequest) => {
    return customAxiosInstance({
        url: `/ops/firms/${firmId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateFirmRequest,
    });
};
export const getPatchFirmOpsMutationOptions = (options) => {
    const mutationKey = ["patchFirmOps"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { firmId, data } = props ?? {};
        return patchFirmOps(firmId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Partially update firm (Ops)
 */
export const usePatchFirmOps = (options) => {
    const mutationOptions = getPatchFirmOpsMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Add a new batch of credits to a firm with expiry date and invoice ID.
Only available to Admin role users for managing firm credit allocations.

**Access**: Admin role only
**Use Cases:**
- Administrative credit management
- Bulk credit allocations
- Credit adjustments and corrections

 * @summary Add credit batch to firm (Ops)
 */
export const addCreditBatchOps = (firmId, addCreditBatchOpsBody, signal) => {
    return customAxiosInstance({
        url: `/ops/firms/${firmId}/credits`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: addCreditBatchOpsBody,
        signal,
    });
};
export const getAddCreditBatchOpsMutationOptions = (options) => {
    const mutationKey = ["addCreditBatchOps"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { firmId, data } = props ?? {};
        return addCreditBatchOps(firmId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Add credit batch to firm (Ops)
 */
export const useAddCreditBatchOps = (options) => {
    const mutationOptions = getAddCreditBatchOpsMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Retrieve all jobs for internal ops team review across all statuses and firms.

**Access**: Admin and Reviewer roles only
**Use Cases:**
- Comprehensive job oversight and monitoring
- Cross-firm job management
- Assignment tracking and reporting
- Performance and quality analysis

 * @summary Get all ops jobs
 */
export const getOpsJobs = (params, signal) => {
    return customAxiosInstance({
        url: `/ops/jobs`,
        method: "GET",
        params,
        signal,
    });
};
export const getGetOpsJobsQueryKey = (params) => {
    return [`/ops/jobs`, ...(params ? [params] : [])];
};
export const getGetOpsJobsQueryOptions = (params, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOpsJobsQueryKey(params);
    const queryFn = ({ signal, }) => getOpsJobs(params, signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Get all ops jobs
 */
export function useGetOpsJobs(params, options) {
    const queryOptions = getGetOpsJobsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Assign a job to the current reviewer for triage processing.

**Access**: Admin and Reviewer roles only

 * @summary Assign job to current reviewer
 */
export const assignJobToReviewerLegacy = (jobId, signal) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/assign`,
        method: "POST",
        signal,
    });
};
export const getAssignJobToReviewerLegacyMutationOptions = (options) => {
    const mutationKey = ["assignJobToReviewerLegacy"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId } = props ?? {};
        return assignJobToReviewerLegacy(jobId);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Assign job to current reviewer
 */
export const useAssignJobToReviewerLegacy = (options) => {
    const mutationOptions = getAssignJobToReviewerLegacyMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Release a job assignment, making it available for other reviewers.

**Access**: Admin and Reviewer roles only

 * @summary Release job assignment
 */
export const releaseJobAssignmentLegacy = (jobId) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/assign`,
        method: "DELETE",
    });
};
export const getReleaseJobAssignmentLegacyMutationOptions = (options) => {
    const mutationKey = ["releaseJobAssignmentLegacy"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId } = props ?? {};
        return releaseJobAssignmentLegacy(jobId);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Release job assignment
 */
export const useReleaseJobAssignmentLegacy = (options) => {
    const mutationOptions = getReleaseJobAssignmentLegacyMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Start automated processing for a triaged job and submit to integrated platforms (e.g., SurePrep).

**Access**: Admin and Reviewer roles only

 * @summary Start job processing
 */
export const startJobProcessing = (jobId, signal) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/start-processing`,
        method: "POST",
        signal,
    });
};
export const getStartJobProcessingMutationOptions = (options) => {
    const mutationKey = ["startJobProcessing"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId } = props ?? {};
        return startJobProcessing(jobId);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Start job processing
 */
export const useStartJobProcessing = (options) => {
    const mutationOptions = getStartJobProcessingMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Retrieve jobs currently assigned to the authenticated reviewer.

**Access**: Admin and Reviewer roles only (must be assigned to jobs)
**Use Cases:**
- Personal job queue for reviewers
- Track assigned work and deadlines
- Monitor ETA adjustments and workload

Jobs are sorted by ETA (earliest deadlines first) and only include jobs
in VERIFICATION or VERIFIED status where the user is the assigned reviewer.

 * @summary Get my active jobs
 */
export const getMyActiveJobs = (params, signal) => {
    return customAxiosInstance({
        url: `/ops/my-jobs`,
        method: "GET",
        params,
        signal,
    });
};
export const getGetMyActiveJobsQueryKey = (params) => {
    return [`/ops/my-jobs`, ...(params ? [params] : [])];
};
export const getGetMyActiveJobsQueryOptions = (params, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMyActiveJobsQueryKey(params);
    const queryFn = ({ signal, }) => getMyActiveJobs(params, signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Get my active jobs
 */
export function useGetMyActiveJobs(params, options) {
    const queryOptions = getGetMyActiveJobsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Retrieve all admin and reviewer users in the system for internal operations.

**Access**: Admin and Reviewer roles only
**Use Cases:**
- Display reviewer names instead of UUIDs in ops portal
- User lookup for job assignments
- Internal user management and reference

Returns comprehensive user details including first name, last name, email,
and role for admin and reviewer users across all firms.

 * @summary List all admin and reviewer users
 */
export const listAllUsers = (params, signal) => {
    return customAxiosInstance({
        url: `/ops/users`,
        method: "GET",
        params,
        signal,
    });
};
export const getListAllUsersQueryKey = (params) => {
    return [`/ops/users`, ...(params ? [params] : [])];
};
export const getListAllUsersQueryOptions = (params, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListAllUsersQueryKey(params);
    const queryFn = ({ signal, }) => listAllUsers(params, signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary List all admin and reviewer users
 */
export function useListAllUsers(params, options) {
    const queryOptions = getListAllUsersQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Retrieve comprehensive dashboard statistics for internal operations.

**Access**: Admin and Reviewer roles only
**Use Cases:**
- Dashboard metrics display
- Real-time count information
- Overdue job tracking
- User assignment analytics

Returns accurate counts without API limits for all dashboard metrics
including job counts by status, overdue jobs, firm counts, and user
assignment statistics.

 * @summary Get dashboard statistics
 */
export const getOpsStats = (signal) => {
    return customAxiosInstance({
        url: `/ops/stats`,
        method: "GET",
        signal,
    });
};
export const getGetOpsStatsQueryKey = () => {
    return [`/ops/stats`];
};
export const getGetOpsStatsQueryOptions = (options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOpsStatsQueryKey();
    const queryFn = ({ signal, }) => getOpsStats(signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Get dashboard statistics
 */
export function useGetOpsStats(options) {
    const queryOptions = getGetOpsStatsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Retrieve the list of available tax software options from SurePrep API.

**Access**: Admin role only
**Use Cases:**
- Populate tax software dropdown when creating or editing firms
- Validate tax software selections in firm configuration
- Administrative setup for SurePrep integration

Returns the complete list of tax software options with both ID and name,
which can be used for firm configuration and user selection interfaces.

 * @summary Get tax software list from SurePrep
 */
export const getOpsTaxSoftware = (signal) => {
    return customAxiosInstance({
        url: `/ops/sureprep/tax-software`,
        method: "GET",
        signal,
    });
};
export const getGetOpsTaxSoftwareQueryKey = () => {
    return [`/ops/sureprep/tax-software`];
};
export const getGetOpsTaxSoftwareQueryOptions = (options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOpsTaxSoftwareQueryKey();
    const queryFn = ({ signal }) => getOpsTaxSoftware(signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Get tax software list from SurePrep
 */
export function useGetOpsTaxSoftware(options) {
    const queryOptions = getGetOpsTaxSoftwareQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Retrieve the list of available office locations from SurePrep API.

**Access**: Admin role only
**Use Cases:**
- Populate office location dropdown when creating or editing firms
- Validate office location selections in firm configuration
- Administrative setup for SurePrep integration

Returns the complete list of office location options with both ID and name,
which can be used for firm configuration and user selection interfaces.

 * @summary Get office locations list from SurePrep
 */
export const getOpsOfficeLocations = (signal) => {
    return customAxiosInstance({
        url: `/ops/sureprep/office-locations`,
        method: "GET",
        signal,
    });
};
export const getGetOpsOfficeLocationsQueryKey = () => {
    return [`/ops/sureprep/office-locations`];
};
export const getGetOpsOfficeLocationsQueryOptions = (options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOpsOfficeLocationsQueryKey();
    const queryFn = ({ signal }) => getOpsOfficeLocations(signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Get office locations list from SurePrep
 */
export function useGetOpsOfficeLocations(options) {
    const queryOptions = getGetOpsOfficeLocationsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Assign a job to a specific reviewer for processing and verification.

**Access**: Admin, Reviewer, and Firm Admin roles
**Use Cases:**
- Initial job assignment to available reviewer
- Self-assignment by reviewers ("Assign to Me")
- Admin assignment of jobs to team members

**Business Rules:**
- Job must be in assignable status (VERIFICATION, VERIFIED, etc.)
- Reviewer must be active and have appropriate permissions
- Assignment is logged to audit trail with context
- Previous assignments are automatically released

 * @summary Assign job to reviewer
 */
export const assignJob = (jobId, assignJobBody, signal) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/assignment`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: assignJobBody,
        signal,
    });
};
export const getAssignJobMutationOptions = (options) => {
    const mutationKey = ["assignJob"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId, data } = props ?? {};
        return assignJob(jobId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Assign job to reviewer
 */
export const useAssignJob = (options) => {
    const mutationOptions = getAssignJobMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Reassign an already assigned job to a different reviewer.

**Access**: Admin, Reviewer, and Firm Admin roles
**Use Cases:**
- Workload balancing between reviewers
- Reviewer unavailability requiring reassignment
- Expertise-based reassignment for complex cases

**Business Rules:**
- Job must currently be assigned to someone
- New reviewer must be different from current assignee
- Reassignment is logged to audit trail with full context
- Notification sent to both old and new assignees

 * @summary Reassign job to different reviewer
 */
export const reassignJob = (jobId, reassignJobBody) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/assignment`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        data: reassignJobBody,
    });
};
export const getReassignJobMutationOptions = (options) => {
    const mutationKey = ["reassignJob"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId, data } = props ?? {};
        return reassignJob(jobId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Reassign job to different reviewer
 */
export const useReassignJob = (options) => {
    const mutationOptions = getReassignJobMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Release a job assignment, making it available for reassignment.

**Access**: Admin, Reviewer, and Firm Admin roles
**Use Cases:**
- Reviewer unavailable and needs to release assigned jobs
- Admin releasing jobs for redistribution
- Clearing assignments during workflow changes

**Business Rules:**
- Job must currently be assigned to someone
- Release is logged to audit trail with context
- Job status may revert to previous state (e.g., TRIAGE)
- Notification sent to previously assigned reviewer

 * @summary Release job assignment
 */
export const releaseJobAssignment = (jobId, params) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/assignment`,
        method: "DELETE",
        params,
    });
};
export const getReleaseJobAssignmentMutationOptions = (options) => {
    const mutationKey = ["releaseJobAssignment"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId, params } = props ?? {};
        return releaseJobAssignment(jobId, params);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Release job assignment
 */
export const useReleaseJobAssignment = (options) => {
    const mutationOptions = getReleaseJobAssignmentMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Update the estimated time of arrival (ETA) for a job in verification.

**Access**: Admin and Reviewer roles only
**Business Rules**:
- Job must be active
- Only the assigned reviewer can adjust their own job ETAs
- ETA cannot be earlier than the original calculated ETA
- ETA cannot be more than 7 days beyond the original ETA
- All adjustments are logged to audit trail

**Use Cases**:
- Reviewer needs additional time due to job complexity
- External delays require ETA adjustment
- Setting realistic client expectations

 * @summary Update job ETA
 */
export const updateJobEta = (jobId, updateJobEtaBody) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/eta`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateJobEtaBody,
    });
};
export const getUpdateJobEtaMutationOptions = (options) => {
    const mutationKey = ["updateJobEta"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId, data } = props ?? {};
        return updateJobEta(jobId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Update job ETA
 */
export const useUpdateJobEta = (options) => {
    const mutationOptions = getUpdateJobEtaMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Update the status of a job directly. This endpoint allows ops users to manually
change job status for administrative purposes.

**Access**: Admin and Reviewer roles only
**Business Rules**:
- Job must exist
- Only specific status transitions are allowed
- All status changes are logged to audit trail

**Use Cases**:
- Manually reset a job to TRIAGE
- Move a job to VERIFICATION status
- Administrative status corrections

 * @summary Update job status
 */
export const updateJobStatus = (jobId, updateJobStatusBody) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/status`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateJobStatusBody,
    });
};
export const getUpdateJobStatusMutationOptions = (options) => {
    const mutationKey = ["updateJobStatus"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId, data } = props ?? {};
        return updateJobStatus(jobId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Update job status
 */
export const useUpdateJobStatus = (options) => {
    const mutationOptions = getUpdateJobStatusMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Set or update the engagement PID on a job to enable Socrates status sync.

**Access**: Admin role only
**Audit**: All changes are logged with previous and new values

 * @summary Update job engagement PID
 */
export const updateJobEngagementPid = (jobId, updateEngagementPidRequest) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/engagement-pid`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateEngagementPidRequest,
    });
};
export const getUpdateJobEngagementPidMutationOptions = (options) => {
    const mutationKey = ["updateJobEngagementPid"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId, data } = props ?? {};
        return updateJobEngagementPid(jobId, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Update job engagement PID
 */
export const useUpdateJobEngagementPid = (options) => {
    const mutationOptions = getUpdateJobEngagementPidMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Manually mark a job as complete, transitioning it from VERIFIED to DONE status.

**Access**: Admin and Reviewer roles only
**Business Rules**:
- Job must be in VERIFIED status
- Triggers email notifications to client
- All processing results must be uploaded before completion

**Use Cases**:
- Reviewer has uploaded all deliverables and verified the job
- Manual completion after review process

 * @summary Complete job manually
 */
export const completeJob = (jobId, signal) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/complete`,
        method: "POST",
        signal,
    });
};
export const getCompleteJobMutationOptions = (options) => {
    const mutationKey = ["completeJob"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId } = props ?? {};
        return completeJob(jobId);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Complete job manually
 */
export const useCompleteJob = (options) => {
    const mutationOptions = getCompleteJobMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Revert a completed job back to VERIFIED status, allowing for corrections or additional work.

**Access**: Admin and Reviewer roles only
**Business Rules**:
- Job must be in DONE status
- Reverts job to VERIFIED status
- Does not affect uploaded processing results

**Use Cases**:
- Need to make corrections to uploaded deliverables
- Additional work required after initial completion
- Accidental completion that needs to be reversed

 * @summary Undo job completion
 */
export const undoCompleteJob = (jobId, signal) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/undo-complete`,
        method: "POST",
        signal,
    });
};
export const getUndoCompleteJobMutationOptions = (options) => {
    const mutationKey = ["undoCompleteJob"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId } = props ?? {};
        return undoCompleteJob(jobId);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Undo job completion
 */
export const useUndoCompleteJob = (options) => {
    const mutationOptions = getUndoCompleteJobMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Sets a `reviewerVerdict` on a single missing-doc entry inside a
binder verification result. Used when a reviewer manually
resolves a missing-doc row — either confirming the file is
actually present in the binder, or that it is not required.

The s3Key is base64url-encoded in the path because it contains
path separators (it points at `firms/.../uploaded-files/...`).

**Access**: Admin and Reviewer roles only

 * @summary Record a reviewer verdict on a missing-doc row (ops)
 */
export const setMissingDocVerdict = (jobId, artifactId, s3KeyB64, setMissingDocVerdictRequest, signal) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/artifacts/${artifactId}/missing-docs/${s3KeyB64}/verdict`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: setMissingDocVerdictRequest,
        signal,
    });
};
export const getSetMissingDocVerdictMutationOptions = (options) => {
    const mutationKey = ["setMissingDocVerdict"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId, artifactId, s3KeyB64, data } = props ?? {};
        return setMissingDocVerdict(jobId, artifactId, s3KeyB64, data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Record a reviewer verdict on a missing-doc row (ops)
 */
export const useSetMissingDocVerdict = (options) => {
    const mutationOptions = getSetMissingDocVerdictMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Reverts a previously-set `reviewerVerdict` on a missing-doc,
returning it to the unresolved state.

**Access**: Admin and Reviewer roles only

 * @summary Clear a reviewer verdict on a missing-doc row (ops)
 */
export const clearMissingDocVerdict = (jobId, artifactId, s3KeyB64) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/artifacts/${artifactId}/missing-docs/${s3KeyB64}/verdict`,
        method: "DELETE",
    });
};
export const getClearMissingDocVerdictMutationOptions = (options) => {
    const mutationKey = ["clearMissingDocVerdict"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId, artifactId, s3KeyB64 } = props ?? {};
        return clearMissingDocVerdict(jobId, artifactId, s3KeyB64);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Clear a reviewer verdict on a missing-doc row (ops)
 */
export const useClearMissingDocVerdict = (options) => {
    const mutationOptions = getClearMissingDocVerdictMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Enqueues an asynchronous verification run for the latest "binder"
artifact and the latest "supporting_doc" (tax-software import)
artifact on the job (at most one per kind). Returns 202 if at
least one was enqueued, 200 if all candidates were already
running, 404 if no candidates exist.

**Access**: Admin and Reviewer roles only

 * @summary Trigger binder verification (ops)
 */
export const triggerBinderVerification = (jobId, signal) => {
    return customAxiosInstance({
        url: `/ops/jobs/${jobId}/verify-binder`,
        method: "POST",
        signal,
    });
};
export const getTriggerBinderVerificationMutationOptions = (options) => {
    const mutationKey = ["triggerBinderVerification"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const mutationFn = (props) => {
        const { jobId } = props ?? {};
        return triggerBinderVerification(jobId);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Trigger binder verification (ops)
 */
export const useTriggerBinderVerification = (options) => {
    const mutationOptions = getTriggerBinderVerificationMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns lightweight summary rows for every binder-bearing job in the
firm. Used by the ops binder-verification page table.

 * @summary Firm binder verification summary
 */
export const getBinderVerificationSummary = (firmId, params, signal) => {
    return customAxiosInstance({
        url: `/ops/firms/${firmId}/binder-verification/summary`,
        method: "GET",
        params,
        signal,
    });
};
export const getGetBinderVerificationSummaryQueryKey = (firmId, params) => {
    return [
        `/ops/firms/${firmId}/binder-verification/summary`,
        ...(params ? [params] : []),
    ];
};
export const getGetBinderVerificationSummaryQueryOptions = (firmId, params, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ??
        getGetBinderVerificationSummaryQueryKey(firmId, params);
    const queryFn = ({ signal }) => getBinderVerificationSummary(firmId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!firmId,
        ...queryOptions,
    };
};
/**
 * @summary Firm binder verification summary
 */
export function useGetBinderVerificationSummary(firmId, params, options) {
    const queryOptions = getGetBinderVerificationSummaryQueryOptions(firmId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
